import $ from 'jquery';

export default function() {
    this.attributes({
        inputSelector: 'input, textarea, select',
        flagSelector:
            '.field--flag__flag > .field__description, .field--flag__flag > .field__message',
    });

    this.updateSelectedViewState = function(event, data) {
        var $input = $(event.target);
        var type = $input.attr('type');

        if (type === 'checkbox') {
            this.updateCheckboxViewState($input);
        } else if (type === 'radio') {
            this.updateRadioViewState($input);
        }
    };

    this.updateRadioViewState = function($input) {
        var $fieldContainer = $input.closest('.field');

        var $container = $input.closest('.fieldset, .field__children, .js-checkbox-set');
        $container.find('.field').removeAttr('data-field-selected');

        $fieldContainer.attr('data-field-selected', '');
    };

    this.updateCheckboxViewState = function($input) {
        var $fieldContainer = $input.closest('.field');
        var checked = $input.prop('checked');
        if (checked) {
            $fieldContainer.attr('data-field-selected', '');
        } else {
            $fieldContainer.removeAttr('data-field-selected');
        }
    };

    this.clickFlagRow = function(event, data) {
        if ($(event.target).is('input') || $(event.target).is('a')) {
            return;
        }

        var $target = $(data.el);
        var $targetInput = $target
            .parent()
            .prev()
            .find('input');

        var checked = $targetInput.prop('checked');
        var disabled = $targetInput.prop('disabled');
        var type = $targetInput.prop('type');

        if (disabled) {
            return;
        }

        if (type === 'checkbox') {
            if (checked) {
                $targetInput.prop('checked', false);
            } else {
                $targetInput.prop('checked', true);
            }
        } else if (type === 'radio') {
            $targetInput.prop('checked', true);
        }

        $targetInput.trigger('change');
    };

    this.after('initialize', function() {
        this.on('change requestUiUpdate', {
            inputSelector: this.updateSelectedViewState,
        });
        this.on('click', {
            flagSelector: this.clickFlagRow,
        });
    });
}



// WEBPACK FOOTER //
// ./src/web/js/app/modules/mixins/with-asimov.js